module.exports = __webpack_public_path__ + "static/media/black_line_chart.5e9e1397.svg";